import { toast } from 'react-toastify'
import URL from 'src/apis/URL'

const GET_DASHBOARD_REQUEST = 'GET_DASHBOARD_REQUEST'
const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'
const GET_DASHBOARD_FAILURE = 'GET_DASHBOARD_FAILURE'

export const getDashboardRequest = () => ({
  type: GET_DASHBOARD_REQUEST,
})

export const getDashboardSuccess = (dashboardData) => ({
  type: GET_DASHBOARD_SUCCESS,
  payload: dashboardData,
})

export const getDashboardFailure = (error) => ({
  type: GET_DASHBOARD_FAILURE,
  payload: error,
})

export const getDashboard = (body) => {
  return async (dispatch) => {
    dispatch(getDashboardRequest())

    try {
      const response = await fetch(`${URL.BASE_URL}${URL.END_POINT.dashboard}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          USERID: localStorage.getItem('USERID'),
          Authorization: `Bearer token=${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(body),
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.message || 'Failed to fetch dashboard data')
      }

      const dashboardData = await response.json()
      dispatch(getDashboardSuccess(dashboardData))
    } catch (error) {
      dispatch(getDashboardFailure(error.message))
      toast.error(error.message)
    }
  }
}

const initialAppState = {
  todayOrders: 0,
  totalOrders: 0,
  weeklyOrders: 0,
  monthlyOrders: 0,
  yearlyOrders: 0,

  pendingOrders: 0,
  completedOrders: 0,
  cancelledOrders: 0,

  todayCancelledOrders: 0,
  weeklyCancelledOrders: 0,
  monthlyCancelledOrders: 0,
  yearlyCancelledOrders: 0,

  todayPendingOrders: 0,
  weeklyPendingOrders: 0,
  monthlyPendingOrders: 0,
  yearlyPendingOrders: 0,

  todayCompletedOrders: 0,
  weeklyCompletedOrders: 0,
  monthlyCompletedOrders: 0,
  yearlyCompletedOrders: 0,

  totalUsers: 0,
  todayRegistrations: 0,
  monthlyRegistrations: 0,
  currentYearRegistrations: 0,
  previousYearRegistrations: 0,

  totalProducts: 0,
  outOfStock: 0,
  categories: [],
  subCategories: [],
  productDetails: [],

  loadingDashboard: false,
  errorDashboard: null,
}

export const dashboardReducer = (state = initialAppState, action) => {
  switch (action.type) {
    case GET_DASHBOARD_REQUEST:
      return {
        ...state,
        loadingDashboard: true,
        errorDashboard: null,
      }

    case GET_DASHBOARD_SUCCESS:
      const data = action.payload.data
      return {
        ...state,
        todayOrders: data.today_orders,
        totalOrders: data.total_orders,
        weeklyOrders: data.weekly_orders,
        monthlyOrders: data.monthly_orders,
        yearlyOrders: data.yearly_orders,

        pendingOrders: data.pending_orders,
        completedOrders: data.completed_orders,
        cancelledOrders: data.cancelled_orders,

        todayCancelledOrders: data.today_cancelled_orders,
        weeklyCancelledOrders: data.weekly_cancelled_orders,
        monthlyCancelledOrders: data.monthly_cancelled_orders,
        yearlyCancelledOrders: data.yearly_cancelled_orders,

        todayPendingOrders: data.today_pending_orders,
        weeklyPendingOrders: data.weekly_pending_orders,
        monthlyPendingOrders: data.monthly_pending_orders,
        yearlyPendingOrders: data.yearly_pending_orders,

        todayCompletedOrders: data.today_completed_orders,
        weeklyCompletedOrders: data.weekly_completed_orders,
        monthlyCompletedOrders: data.monthly_completed_orders,
        yearlyCompletedOrders: data.yearly_completed_orders,

        totalUsers: data.total_users,
        todayRegistrations: data.today_registrations,
        monthlyRegistrations: data.monthly_registrations,
        currentYearRegistrations: data.current_year_registrations,
        previousYearRegistrations: data.previous_year_registrations,

        totalProducts: data.product[0]?.[0]?.total_products,
        outOfStock: data.product[1]?.[0]?.out_of_stock,
        productDetails: data.product[2]?.map((item) => ({ id: item.id, name: item.product_name })),
        categories: data.product[3]?.map((item) => ({
          id: item.id,
          name: item.category_name,
          count: item.category_count,
        })),
        subCategories: data.product[4]?.map((item) => ({
          id: item.id,
          name: item.sub_category_name,
          count: item.sub_category_count,
        })),

        loadingDashboard: false,
        errorDashboard: null,
      }

    case GET_DASHBOARD_FAILURE:
      return {
        ...state,
        loadingDashboard: false,
        errorDashboard: action.payload,
      }

    default:
      return state
  }
}
